import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NoData from "assets/svgs/no_data/NoData";
import classNames from "classnames";
import { fourPlaceHolder } from "modules/utilities/utility";
import React, { useState } from "react";
import { calculatePercentage } from "./commonFunction";

function CampaignMediumTable({
  mediumTodayGroupedData,
  mediumYesterdayGroupedData,
  sourceTodayGroupedData,
  sourceYesterdayGroupedData,
  checkboxes,
  option
}) {
  const mappedOrgKey =checkboxes==="utm_medium"?Object.keys(mediumTodayGroupedData):Object.keys(sourceTodayGroupedData);
  const mappedOrgYesterdayKey = checkboxes==="utm_medium"?Object.keys(mediumYesterdayGroupedData):Object.keys(sourceYesterdayGroupedData);

  const mappedKey=!option? mappedOrgKey:mappedOrgKey?.filter((item)=>{
    return item===option;
  })
  const mappedYesterdayKey=!option?mappedOrgYesterdayKey: mappedOrgYesterdayKey?.filter((item)=>{
    return item===option;
  })

  return (
    <div>
      <div
        className="mt-1 shadow rounded mt-2 scrollable-container"
        style={{ maxHeight: "70vh", overflowY: "scroll" }}
      >
        <div
          className="d-flex table-head rounded-top"
          style={{ position: "sticky", top: "0" }}
        >
          <span className="p-3 py-4 fw-bold text-black flex-1 border-end">
            {checkboxes == "utm_source" ? "UTM Source" : "UTM Medium"}
          </span>
          <span className="p-3 py-4 fw-bold text-black flex-1 border-end">
            Order
          </span>
          <span className="p-3 py-4 fw-bold text-black flex-1 border-end">
            Gross
          </span>
        </div>
        {false ? (
          fourPlaceHolder()
        ) : mappedKey?.length ? (
          mappedKey?.map((item, index) => {
            const itemTodayObj =
              checkboxes === "utm_medium"
                ? mediumTodayGroupedData[item]
                : sourceTodayGroupedData[item];
            const itemYesterdayObj =
              checkboxes === "utm_medium"
                ? mediumYesterdayGroupedData[item]
                : sourceYesterdayGroupedData[item];
            const aggregatedTodayData = itemTodayObj?.reduce((acc, entry) => {
              const medium =checkboxes === "utm_medium"? entry.utm_medium:entry.utm_source;

              acc[medium] = acc[medium] || { count: 0, sum: 0 };
              acc[medium].count += parseInt(entry.count);
              acc[medium].sum += parseFloat(entry.sum);
              return acc;
            }, {});
            const aggregatedYesterdayData = itemYesterdayObj?.reduce(
              (acc, entry) => {
                const medium =checkboxes === "utm_medium"? entry.utm_medium:entry.utm_source;

                acc[medium] = acc[medium] || { count: 0, sum: 0 };
                acc[medium].count += parseInt(entry.count);
                acc[medium].sum += parseFloat(entry.sum);
                return acc;
              },
              {}
            );

            if(!mappedYesterdayKey?.includes(item)){
                return;
            }

            return (
              <div
                className={`d-flex table-row border-1 border-top-0 ${
                  index === mappedKey?.length - 1 && `rounded-bottom`
                }`}
              >
                <span className="p-3 flex-1 text-break text-black font-bold text-wrap border-end">
                  {item || "NULL"}
                </span>

                <span className="p-3  flex-1 text-break text-black text-wrap border-end">
                  <p className="font-sans-serif lh-1 mb-1 fs-2">
                    {aggregatedTodayData[item]?.count.toFixed(2)}
                  </p>
                  <div className="d-flex align-items-center">
                    <h6 className="fs--1 text-500 mb-0">
                      {aggregatedYesterdayData[item]?.count.toFixed(2)}
                    </h6>
                    <h6
                      className={classNames("fs--2 ps-3 mb-0", {
                        "text-success": "standard" === "up",
                        "text-danger": "standard" === "down",
                        "text-primary": "standard" === "standard",
                        "text-warning": "standard" === "warning",
                        "text-info": "standard" === "pending",
                      })}
                    >
                      <FontAwesomeIcon
                        icon={
                          Number(aggregatedTodayData[item]?.count) >
                          Number(aggregatedYesterdayData[item]?.count)
                            ? "caret-up"
                            : "caret-down"
                        }
                        className={
                          Number(aggregatedTodayData[item]?.count) <
                          Number(aggregatedYesterdayData[item]?.count)
                            ? "me-1 text-danger"
                            : "me-1"
                        }
                      />
                      {calculatePercentage(
                        aggregatedTodayData[item]?.count,
                        aggregatedYesterdayData[item]?.count
                      )}
                      %
                    </h6>
                  </div>
                </span>
                <span className="p-3  flex-1 text-break text-black text-wrap border-end">
                  <p className="font-sans-serif lh-1 mb-1 fs-2">
                    &#x20B9; {aggregatedTodayData[item]?.sum.toFixed(2)}
                  </p>
                  <div className="d-flex align-items-center">
                    <h6 className="fs--1 text-500 mb-0">
                      &#x20B9; {aggregatedYesterdayData[item]?.sum.toFixed(2)}
                    </h6>
                    <h6
                      className={classNames("fs--2 ps-3 mb-0", {
                        "text-success": "standard" === "up",
                        "text-danger": "standard" === "down",
                        "text-primary": "standard" === "standard",
                        "text-warning": "standard" === "warning",
                        "text-info": "standard" === "pending",
                      })}
                    >
                      <FontAwesomeIcon
                        icon={
                          Number(aggregatedTodayData[item]?.sum.toFixed(2)) >=
                          Number(aggregatedYesterdayData[item]?.sum)
                            ? "caret-up"
                            : "caret-down"
                        }
                        className={
                            Number(aggregatedTodayData[item]?.sum.toFixed(2)) <
                            Number(aggregatedYesterdayData[item]?.sum)
                            ? "me-1 text-danger"
                            : "me-1"
                        }
                      />
                      {calculatePercentage(
                        +aggregatedTodayData[item]?.sum,
                        +aggregatedYesterdayData[item]?.sum
                      )}
                      %
                    </h6>
                  </div>
                </span>
              </div>
            );
          })
        ) : (
          <div className="p-3 bg-white rounded-bottom text-center">
            No Data Available <NoData />
          </div>
        )}
      </div>
    </div>
  );
}

export default CampaignMediumTable;

